import domReady from '@wordpress/dom-ready';

/**
 * Create a sidebar navigation menu based on the headers in the document.
 */
function createSidebarMenu() {
  /** * Add unique IDs to headers in the document. */
  const headers = document.querySelectorAll(
    'h2:not(.survey-block .gform_title)'
  );

  for (let i = 0; i < headers.length; i++) {
    // Create an ID based on the textual content of the title
    let id = headers[i].textContent
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .toLowerCase();

    // If an item with the same ID already exists, add the index to the ID
    if (document.getElementById(id)) {
      id = id + '-' + i;
    }

    // Assign the ID to the title element
    headers[i].id = id;
  }

  const navMenu = document.getElementById('sidebarMenu');

  for (let i = 0; i < headers.length; i++) {
    const listItem = document.createElement('li');

    const link = document.createElement('a');

    link.setAttribute('href', '#' + headers[i].id);

    link.textContent = headers[i].textContent;

    listItem.appendChild(link);

    navMenu.appendChild(listItem);
  }
}

domReady(() => {
  const sidebar = document.querySelector('.sidebar-container');
  const sidebarMenu = document.querySelector('#sidebarMenu');

  if (sidebar) {
    document.body.classList.add('template-page-with-sidebar-menu');
    createSidebarMenu();

    if (!sidebarMenu.querySelector('li')) {
      sidebar.classList.add('sidebar-container--empty');
    }

    const anchors = document.querySelectorAll('#sidebarMenu li a');
    if (anchors.length > 0) {
      anchors.forEach((anchor) => {
        anchor.addEventListener('click', () => {
          anchors.forEach((a) =>
            a.classList.remove('sidebar-menu-item--active')
          );
          anchor.classList.add('sidebar-menu-item--active');
        });
      });
    }

    window.addEventListener('scroll', () => {
      const sidebarMenuLinks = $('#sidebarMenu li a');
      if (sidebarMenuLinks) {
        sidebarMenuLinks.each(function () {
          const currLink = $(this);
          const refElement = $(currLink.attr('href'));
          const topOfElement = refElement.offset().top;
          const bottomOfElement =
            refElement.offset().top + refElement.outerHeight();
          const bottomOfScreen =
            $(window).scrollTop() + $(window).innerHeight();
          const topOfScreen = $(window).scrollTop();

          if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement) {
            currLink.addClass('sidebar-menu-item--active');
          } else {
            currLink.removeClass('sidebar-menu-item--active');
          }
        });
      }
    });
  }
});
